export default __webpack_public_path__ + "static/media/orange1-big.e294ae9a.png";